/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 197,
    saturation: 33,
    lightness: 75,
  },
  darker: {
    hue: 197,
    saturation: 100,
    lightness: 30,
  },
  contrastText: {
    hue: 200,
    saturation: 30,
    lightness: 25,
  },
  background: {
    hue: 200,
    saturation: 33,
    lightness: 83,
  },
  backgroundContrastText: {
    hue: 203,
    saturation: 17,
    lightness: 35,
  },
};
